import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import StatsMarquee from "@/components/site/StatsMarquee";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import CaseStudies from "@/components/site/CaseStudies";
import Testimonials from "@/components/site/Testimonials";
import Pricing from "@/components/site/Pricing";
import Resources from "@/components/site/Resources";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";

const Landing = () => (
  <main data-testid="landing-page" className="min-h-screen bg-zinc-950 text-zinc-50 overflow-x-hidden">
    <Nav />
    <Hero />
    <StatsMarquee />
    <Services />
    <Process />
    <CaseStudies />
    <Testimonials />
    <Pricing />
    <Resources />
    <Contact />
    <Footer />
    <WhatsAppFab />
    <Toaster
      theme="dark"
      position="bottom-center"
      toastOptions={{
        style: {
          background: "#18181b",
          color: "#fafafa",
          border: "1px solid rgba(250, 204, 21, 0.25)",
        },
      }}
    />
  </main>
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
